import React, {ReactNode} from "react";
import DomHelper from "../../helper/DomHelper";
import Translate from "../../translation/Translate";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class InitialHereStamp extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let id: string = "gradient-" + DomHelper.generateUUID();

		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox={"0 0 300 70"}>
				<g style={{
					opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
					transformOrigin: "50% 50%"
				}}>
					<defs>
						<linearGradient id={id} x1={0} x2="100%" y1={0} y2={0}>
							<stop offset={0} style={{stopOpacity: 1, stopColor: "#CBC5E0"}}/>
							<stop offset="100%" style={{stopOpacity: 1, stopColor: "#928DC2"}}/>
						</linearGradient>
					</defs>
					{FunctionHelper.exists(this.props.onMoveStart) &&
						<polygon points="0,35 50,0 300,0 300,70 50,70" className="movearea"
                                 onClick={this.props.onClick} onContextMenu={this.props.onContextMenu}
								 onPointerDown={this.props.onMoveStart}/>
					}
					<polygon points="0,35 50,0 300,0 300,70 50,70" style={{
						fill: "#CBC5E0",
						strokeWidth: 1,
						stroke: "#585692"
					}}/>
					<text x="20%" y={45} style={{
						fontWeight: "bold",
						fontStyle: "italic",
						textAnchor: "start",
						textTransform: "uppercase",
						fontSize: "25px",
						fill: "#282425"
					}}>
						<Translate {...this.props} data="annotation.stamp_types.initial_here" namespace="sidebar"/>
					</text>
				</g>
			</svg>
		);
	}
}